import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../lib/api';
import MatchLobby from './MatchLobby';
import InGame from './InGame';
import MatchResult from './MatchResult';
import { io, Socket } from 'socket.io-client';

const Match = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [match, setMatch] = useState<any>(null);
  const [socket, setSocket] = useState<Socket | null>(null);

  const fetchMatch = useCallback(async () => {
    try {
      const response = await api.get(`/matches/${id}`);
      console.log('Match data fetched, status:', response.data.status);
      setMatch(response.data);
    } catch (error) {
      console.error('Error fetching match:', error);
    }
  }, [id]);

  useEffect(() => {
    fetchMatch();

    // Connect to socket for real-time updates
    const token = localStorage.getItem('token');
    const socketUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    const newSocket = io(socketUrl, {
      auth: { token }
    });

    newSocket.on('connect', () => {
      console.log('Socket connected, joining match:', id);
      if (id) {
        newSocket.emit('joinMatch', id);
      }
    });

    newSocket.on('matchAccepted', (data) => {
      console.log('Socket: Match accepted event received', data);
      // Refresh match data when it's accepted
      fetchMatch();
    });

    newSocket.on('matchRejected', (data) => {
      console.log('Socket: Match rejected event received', data);
      // Redirect or show message when match is rejected
      alert('Zápas byl odmítnut druhým týmem');
      navigate('/');
    });

    newSocket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
    });

    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, [fetchMatch, id, navigate]);

  useEffect(() => {
    if (!match) {
      return;
    }

    if (match.status !== 'finished') {
      localStorage.setItem('activeMatchId', match.id);
    } else {
      localStorage.removeItem('activeMatchId');
    }
  }, [match]);

  if (!match) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary-50 via-secondary-50 to-accent-50 flex items-center justify-center p-4">
        <div className="text-center animate-fade-in">
          <div className="text-6xl mb-6 animate-bounce-slow">⚽</div>
          <div className="text-2xl font-bold text-gray-900 mb-4">Načítám zápas...</div>
          <div className="flex justify-center space-x-2">
            <div className="w-3 h-3 bg-primary-500 rounded-full animate-bounce"></div>
            <div className="w-3 h-3 bg-secondary-500 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-3 h-3 bg-accent-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      {match.status === 'pending' && <MatchLobby match={match} onMatchUpdate={fetchMatch} />}
      {match.status === 'started' && <InGame match={match} onMatchFinished={fetchMatch} />}
      {match.status === 'finished' && <MatchResult match={match} />}
    </div>
  );
};

export default Match;
